/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Teams,
} from '../../utils/api';
import { ARMcontext } from '../../utils/context/context';
import { useInputValue } from '../../utils/hooks/useInputValue';
import {
  LabelsWrapper,
  LabelsContainer,
  TextContainer,
  AlertContainer,
  Oval,
  HideContainer,
} from './wellness/styles';
import {
  Exams,
  Scorecard,
  Health,
  Velocity,
  Workloads,
  Wellness,
  Accountability,
  KeyMetrics,
  ActionItems,
  Leaderboard,
  PlayerExams,
  PlayerKeyMetrics,
  PlayerScorecard,
  PlayerHealth,
  PlayerVelocity,
  PlayerWorkloads,
  PlayerWellness,
  PlayerAccountability,
} from './';

import { Routes, Route, useParams, useLocation, useNavigate, Outlet } from 'react-router-dom';
import {
  ContainerLeft,
  ButtonWrapper,
  ContainerRight,
  DropdownWrapper,
  PlayersContainer,
  PlayersDataSection,
  PlayersFilterSection,
  MessageText,
} from './styles';
import {
  Navbar,
  PreviusTab,
  FiltersContainer,
  PowerDropdown,
  Tabs,
  InputComponent,
  LargeButton,
  Modal,
  EditTeam,
  PlayerBanner,
} from '../../components';
import { TeamDataResponse } from '../../interfaces/Results';
import { TeamsCacheKey } from '../../utils/constants/keyCache';

const DefaultPlayers = [
  { title: 'Players', lenght: 50, value: '' },
  { title: 'Pitchers', lenght: 20, value: 'Pitchers' },
  { title: 'Catchers', lenght: 30, value: 'Catchers' },
];

const DefaultAlerts = [
  { title: 'Alerts', lenght: 10, color: '', alert: false, value: '' },
  { title: 'Pain', lenght: 30, color: '#f84958e6', alert: true, value: 'Pain' },
];

const acceptedRoutes = [
  // KeyMetrics
  '/players/keyMetrics/strength',
  '/players/keyMetrics/fatigue',

  // Exams
  '/players/exams/fresh/strength',
  '/players/exams/fresh/rom',
  '/players/exams/post/strength',
  '/players/exams/post/rom',
  '/players/exams/primer/strength',

  // Accountability
  '/players/accountability/training',
  '/players/accountability/exams',

  // Wellness
  '/players/wellness',

  // Action Items
  '/players/actionItems',

  // Otros
  '/players/health',
  '/players/scorecard',
  '/players/velocityTest/previous',
  '/players/playerWorkloads',
  '/players/leaderboard'
];

const TeamPills = [
  {
    title: 'Key Metrics',
    url: 'keyMetrics',
  },
  {
    title: 'Exams',
    url: 'exams',
  },
  {
    title: 'Accountability',
    url: 'accountability',
  },
  {
    title: 'Wellness',
    url: 'wellness',
  },
  {
    title: 'Action Items',
    url: 'actionItems',
  }
];

const PlayerPills = [
  {
    title: 'Key Metrics',
    url: 'keyMetrics',
  },
  {
    title: 'Exams',
    url: 'exams',
  },
  {
    title: 'Accountability',
    url: 'accountability',
  },

  {
    title: 'Wellness',
    url: 'wellness',
  },
];

const toastPromise = {
  pending: 'The file is being generated',
  success: 'File downloaded! 🔥',
  error: 'There was an error on our side!',
};

export default () => {
  const { teamMemo, selectedTeam, selectedPlayer, HandleSelectedTeam, AddNewTeams, user, ToggleReload } = useContext(ARMcontext);
  const [defaultPlayers, useDefaultPlayers] = useState<Array<any>>(DefaultPlayers);
  const [defaultAlerts, useDefaultAlerts] = useState<Array<any>>(DefaultAlerts);
  const [isDownloadDisabled, useisDownloadDisabled] = useState(false);
  const [players, usePlayers] = useState<any>(defaultPlayers[0]);
  const [alerts, useAlerts] = useState<any>(DefaultAlerts[0]);
  const [isFirstLoad, setFirstLoad] = useState(true);
  const [modal, useModal] = useState<boolean>(false);
  const [debouncedFilterValue, setDebouncedFilterValue] = useState('');
  const filterPlayer = useInputValue('', 'search');
  const location = useLocation();
  const Team = new Teams();
  const [keyScaleModal, setKeyScaleModal] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const debounce = useCallback((func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  }, []);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setDebouncedFilterValue(value);
    }, 300),
    []
  );

  useEffect(() => {
    debouncedSearch(filterPlayer.value);
  }, [filterPlayer.value, debouncedSearch]);

  useEffect(() => {
    if (location.pathname === '/players/actionItems') filterPlayer.onChange({ target: { value: '' } });
  }, [location])

  useEffect(() => {
    if (acceptedRoutes.includes(location.pathname)) {
      FetchTeams();
    }
  }, []);


  useEffect(() => {
    if (!isFirstLoad && (selectedTeam._id || selectedTeam.__name)) {
      FetchTeams();
    }
  }, [selectedTeam._id, selectedTeam.__name]);

  function BuildPlayersFilter(activeTeam = selectedTeam) {
    const buildPlayers = [
      {
        title: 'Players',
        lenght: activeTeam?.players?.length?.toString() || activeTeam?.totalPlayers?.toString(),
        value: '',
      },
      {
        title: 'Pitchers',
        lenght: activeTeam?.pitchers?.toString() || '0',
        value: 'Pitchers',
      },
      {
        title: 'Catchers',
        lenght: activeTeam?.catchers?.toString() || '0',
        value: 'Catchers',
      },
      {
        title: 'Infielders',
        lenght: activeTeam?.infielders?.toString() || '0',
        value: 'Infielders',
      },
      {
        title: 'Outfielders',
        lenght: activeTeam?.outfielders?.toString() || '0',
        value: 'Outfielders',
      },
    ];
    usePlayers(prev => {
      const activePlayer = buildPlayers.find(el => prev.title === el.title);
      if (activePlayer && (prev.title !== activePlayer.title || prev.lenght !== activePlayer.lenght)) {
        return {
          title: activePlayer.title,
          lenght: activePlayer.lenght,
          value: activePlayer.value,
        };
      }
      return prev;
    });
    useDefaultPlayers(buildPlayers);
  }

  const ChangeTeam = useCallback((activeTeam = selectedTeam) => {
    HandleSelectedTeam(activeTeam);
  }, [selectedTeam, HandleSelectedTeam]);

  const ChangePlayers = useCallback((selectedOption) => {
    usePlayers(selectedOption);
  }, []);


  function HandleTeamStatus(): void {
    HandleSelectedTeam(teamMemo[0]);
  }

  function HandlePlayersStatus(): void {
    usePlayers(defaultPlayers[0]);
  }

  function ChangeAlerts(selectedOption: any): void {
    useAlerts(selectedOption);
  }

  function HandleAlertStatus(): void {
    useAlerts(defaultAlerts[0]);
  }

  async function FetchTeams(isEdit=false, isCacheable=true): Promise<void> {
    let fetchedTeams: any[] = [];
    if(isEdit){
      let res: TeamDataResponse;
      if(isCacheable){
        res = await Team.ExecuteCacheRequest({
          cacheKey: TeamsCacheKey,
          queryFn: Team.GetMyTeams,
        });
      } else {
        res = await Team.ExecuteCacheRequest({
          isForceDelete: true,
          cacheKey: TeamsCacheKey,
          queryFn: Team.GetMyTeams,
        });
      }

      if (res.status) {
        const allValues = {
          pitchers: res.data.meta.players.all.pitchers,
          catchers: res.data.meta.players.all.catchers,
          infielders: res.data.meta.players.all.infielders,
          outfielders: res.data.meta.players.all.outfielders,
        };
        const AllPlayers = {
          ...allValues,
          age: [],
          color: '#007AFF',
          badge: 'ALL',
          name: 'All Players',
          totalPlayers: res.data.meta.players.total,
          __name: 'All Players',
          __organization: 'ARM CARE',
          __organizationToStr: 'ARM CARE',
        };
        AddNewTeams([AllPlayers, ...res.data.teams]);
        fetchedTeams = [...res.data.teams];
      }
    } else {
      fetchedTeams = [...teamMemo];
    }
    BuildPlayersFilter(fetchedTeams.filter(el => el._id === selectedTeam._id)[0]);
    setFirstLoad(false)
  }

  async function RecallMyTeams(){
    await FetchTeams(true);
  }

  function HandleEditTeam(value = !modal) {
    useModal(value);
    if (!value) {
      ToggleReload();
      FetchTeams(true);
    }
  }

  async function HandleOrgCsv(onlyAllData?: boolean) {
    useisDownloadDisabled(true);

    if (selectedTeam.badge === 'ALL') {
      await toast.promise(Team.GetTeamCSV('', false, onlyAllData), toastPromise);
    } else {
      await toast.promise(Team.GetTeamCSV(selectedTeam._id, true, onlyAllData), toastPromise);
    }
    useisDownloadDisabled(false);
  }

  const renderPlayer = useMemo(() => {
    if(selectedPlayer?.name){
      return <SelectedPlayerRouter filterPlayer={debouncedFilterValue} playersGroup={players.value} />
    } else {
        return <PlayersRouter
        isFirstLoad={isFirstLoad}
        filterPlayer={debouncedFilterValue}
        playersGroup={players.value === undefined ? '' : players.value}
        useDefaultAlerts={useDefaultAlerts}
        alerts={alerts}
        useAlerts={useAlerts}
        keyScaleModal={keyScaleModal}
        setKeyScaleModal={setKeyScaleModal}
      />
    }
  }, [isFirstLoad, debouncedFilterValue, players, alerts, keyScaleModal, selectedPlayer]);

  return (
    <>
      <ToastContainer />
      <Navbar />
      <PreviusTab />
      <FiltersContainer cy-data="players_filters">
        {selectedPlayer?.name ? (
          <>
            <PlayerBanner selectedPlayer={selectedPlayer} />
          </>
        ) : (
          <PlayersContainer data-cy="players-filters">
            <ContainerLeft>
              <DropdownWrapper>
                <PowerDropdown
                  primaryTitle={selectedTeam.name}
                  badge={selectedTeam?.initials || selectedTeam.badge}
                  colorBadge={selectedTeam.color}
                  picture={selectedTeam.picture}
                  search={true}
                  status={true}
                  handleStatus={HandleTeamStatus}
                  onClick={ChangeTeam}
                  dataArray={teamMemo}
                  mPadding="4px 0 4px 10px;z-index:1000"
                  mWidth="308px"
                  disabled={isFirstLoad}
                />
              </DropdownWrapper>
              <DropdownWrapper>
                <PowerDropdown
                  primaryTitle={players.title}
                  visibleLenght={players.lenght}
                  search={false}
                  status={true}
                  handleStatus={HandlePlayersStatus}
                  onClick={ChangePlayers}
                  dataArray={defaultPlayers}
                  mPadding="4px 0 4px 10px;z-index:1000"
                />
              </DropdownWrapper>
              <DropdownWrapper className='message-wrapper'>
                <MessageText>
                  Only players with data are shown
                </MessageText>
              </DropdownWrapper>
              <HideContainer>
                <DropdownWrapper>
                  {window.location.href.includes('/players/exams') && (
                    <PowerDropdown
                      primaryTitle={alerts.title}
                      visibleLenght={alerts.lenght}
                      search={false}
                      status={true}
                      color={alerts.color}
                      handleStatus={HandleAlertStatus}
                      onClick={ChangeAlerts}
                      dataArray={defaultAlerts}
                      mPadding="4px 0 4px 10px"
                    />
                  )}
                </DropdownWrapper>
              </HideContainer>
            </ContainerLeft>
            <ContainerRight>
              {!(selectedTeam.badge === 'ALL') ? (
                <>
                  {user.role === 'org-admin' || user.data.isAdmin ? (
                    <>
                      <InputComponent responsive="770px" dynamicSearch={filterPlayer} animateWidth="30%" placeholder="Search" />

                      <ButtonWrapper>
                        <LargeButton
                          title="EDIT TEAM"
                          lColor="var(--SecondaryBlue);"
                          rColor="var(--PrimaryBlue);"
                          icon="save"
                          responsive="770px"
                          callback={HandleEditTeam}
                        />
                      </ButtonWrapper>
                    </>
                  ) : (
                    <InputComponent responsive="770px" dynamicSearch={filterPlayer} animateWidth="50%" placeholder="Search" />
                  )}
                </>
              ) : (
                <InputComponent responsive="770px" dynamicSearch={filterPlayer} animateWidth="50%" placeholder="Search" />
              )}
              <ButtonWrapper>
                <LargeButton
                  title="TEAM XLSX"
                  lColor="var(--SecondaryGreen);"
                  rColor="var(--PrimaryGreen);"
                  icon="excel"
                  responsive="770px"
                  callback={() => HandleOrgCsv()}
                  disabled={isDownloadDisabled}
                />
                <LargeButton
                  title="TEAM CSV"
                  lColor="var(--SecondaryGreen);"
                  rColor="var(--PrimaryGreen);"
                  icon="excel"
                  responsive="770px"
                  xMargin="0 0 0 10px"
                  callback={() => HandleOrgCsv(true)}
                  disabled={isDownloadDisabled}
                />
              </ButtonWrapper>
            </ContainerRight>
          </PlayersContainer>
        )}
      </FiltersContainer>

      <PlayersDataSection>
        <FiltersContainer bColor="var(--BackgroundGrey)">
          <PlayersFilterSection>
            <Tabs dataArray={selectedPlayer?.name ? PlayerPills : TeamPills} url={'/players'} />
            {window.location.href.includes('players/wellness') && (
              <LabelsWrapper>
                <TextContainer>WELLNESS ALERT</TextContainer>
                <LabelsContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'yellow'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'red'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'blue'} />
                    <span> Medical</span>
                  </AlertContainer>
                </LabelsContainer>
              </LabelsWrapper>
            )}
          </PlayersFilterSection>
        </FiltersContainer>
        <Routes>
          <Route path={`:playersId/*`} element={renderPlayer} />
        </Routes>
      </PlayersDataSection>
      {modal && (
        <Modal title="Edit Team" margin="6vh auto 200px auto">
          <EditTeam HandleEditTeam={HandleEditTeam} RecallMyTeams={RecallMyTeams} />
        </Modal>
      )}
    </>
  );
};

const PlayersRouter = ({
  isFirstLoad,
  filterPlayer,
  playersGroup,
  useDefaultAlerts,
  alerts,
  useAlerts,
  keyScaleModal,
  setKeyScaleModal,
}: {
  isFirstLoad: boolean;
  filterPlayer: any;
  playersGroup: string;
  useDefaultAlerts: any;
  alerts: any;
  useAlerts: any;
  keyScaleModal?: any;
  setKeyScaleModal?: any;
}) => {
  const { playersId } = useParams() as any;

  return (
    <>
      {playersId === 'exams' ? (
        <Exams
          isFirstLoad={isFirstLoad}
          playersGroup={playersGroup}
          playerNameSearch={filterPlayer}
          alerts={alerts}
          useAlerts={useAlerts}
          useDefaultAlerts={useDefaultAlerts}
        />
      ) : playersId === 'health' ? (
        <Health />
      ) : playersId === 'scorecard' ? (
        <Scorecard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : playersId === 'velocityTest' ? (
        <Velocity />
      ) : playersId === 'playerWorkloads' ? (
        <Workloads />
      ) : playersId === 'accountability' ? (
        <Accountability
          isFirstLoad={isFirstLoad}
          playersGroup={playersGroup}
          playerNameSearch={filterPlayer}
        />
      ) : playersId === 'wellness' ? (
        <Wellness
          isFirstLoad={isFirstLoad}
          playersGroup={playersGroup}
          playerNameSearch={filterPlayer}
        />
      ) : playersId === 'leaderboard' ? (
        <Leaderboard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : playersId === 'keyMetrics' ? <KeyMetrics
      isFirstLoad={isFirstLoad}
      playersGroup={playersGroup}
      keyScaleModal={keyScaleModal}
      playerNameSearch={filterPlayer}
      setKeyScaleModal={setKeyScaleModal}
    /> : playersId === 'actionItems' ? (
        <ActionItems isFirstLoad={isFirstLoad} playersGroup={playersGroup} playerNameSearch={filterPlayer} />
      ) : (
        <></>
      )}
    </>
  );
};
const SelectedPlayerRouter = ({ playersGroup, filterPlayer }) => {
  const { playersId } = useParams() as any;
  return (
    <>
      {playersId === 'exams' ? (
        <PlayerExams />
      ) : playersId === 'keyMetrics' ? (
        <PlayerKeyMetrics />
      ) : playersId === 'health' ? (
        <PlayerHealth />
      ) : playersId === 'scorecard' ? (
        <PlayerScorecard />
      ) : playersId === 'velocityTest' ? (
        <PlayerVelocity />
      ) : playersId === 'playerWorkloads' ? (
        <PlayerWorkloads />
      ) : playersId === 'accountability' ? (
        <PlayerAccountability playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : playersId === 'wellness' ? (
        <PlayerWellness />
      ) : playersId === 'leaderboard' ? (
        <Leaderboard playersGroup={playersGroup} playerNameSearch={filterPlayer.value} />
      ) : (
        <></>
      )}
    </>
  );
};
